/* Lightbox for the frame cluster's figures: review photos and the methodology
   apparatus set. Hand written, not generated. No dependencies.

   Binds to any <img> inside a figure carrying .frev-fig or .fmeth-rig, so a new
   figure in either builder is clickable with no extra wiring. The compare tool
   is deliberately excluded: it has its own zoom and pan, and hijacking a click
   there would break the wipe handle. */
(function () {
  var SEL = '.frev-fig img, .fmeth-rig img, .fmeth-me img';
  var items = [], idx = 0, box, imgEl, capEl, lastFocus;

  function collect() {
    items = [].slice.call(document.querySelectorAll(SEL)).filter(function (im) {
      return im.currentSrc || im.src;
    });
  }

  function build() {
    box = document.createElement('div');
    box.className = 'fbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<button class="fbox-x" type="button" aria-label="Close">&times;</button>' +
      '<button class="fbox-nav fbox-prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<button class="fbox-nav fbox-next" type="button" aria-label="Next">&#8250;</button>' +
      '<figure class="fbox-fig"><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(box);
    imgEl = box.querySelector('img');
    capEl = box.querySelector('figcaption');

    box.querySelector('.fbox-x').addEventListener('click', close);
    box.querySelector('.fbox-prev').addEventListener('click', function (e) {
      e.stopPropagation(); go(-1);
    });
    box.querySelector('.fbox-next').addEventListener('click', function (e) {
      e.stopPropagation(); go(1);
    });
    // click anywhere that is not the image itself closes
    box.addEventListener('click', function (e) {
      if (e.target === imgEl) return;
      close();
    });
  }

  function show(i) {
    idx = (i + items.length) % items.length;
    var im = items[idx];
    var fig = im.closest('figure');
    var cap = fig && fig.querySelector('figcaption');
    imgEl.src = im.currentSrc || im.src;
    imgEl.alt = im.alt || '';
    capEl.textContent = cap ? cap.textContent : (im.alt || '');
    capEl.hidden = !capEl.textContent;
    var many = items.length > 1;
    box.querySelector('.fbox-prev').hidden = !many;
    box.querySelector('.fbox-next').hidden = !many;
  }

  function go(d) { show(idx + d); }

  function open(i) {
    if (!box) build();
    lastFocus = document.activeElement;
    show(i);
    box.hidden = false;
    document.documentElement.classList.add('fbox-lock');
    box.querySelector('.fbox-x').focus();
  }

  function close() {
    if (!box || box.hidden) return;
    box.hidden = true;
    imgEl.removeAttribute('src');
    document.documentElement.classList.remove('fbox-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var im = e.target.closest && e.target.closest(SEL);
    if (!im) return;
    e.preventDefault();
    collect();
    var i = items.indexOf(im);
    if (i >= 0) open(i);
  });

  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  });

  // make the affordance real for keyboard and screen reader users too
  function tag() {
    document.querySelectorAll(SEL).forEach(function (im) {
      if (im.dataset.fbox) return;
      im.dataset.fbox = '1';
      im.tabIndex = 0;
      im.setAttribute('role', 'button');
      im.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        collect();
        var i = items.indexOf(im);
        if (i >= 0) open(i);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tag);
  } else { tag(); }
}());
